import ImgMenu1 from '../../../assets/images/img-menu.png';
import ItemMenu1 from '../../../assets/images/itemMenu1.jpg';
import ItemMenu2 from '../../../assets/images/itemMenu2.jpg';
import ItemMenu3 from '../../../assets/images/itemMenu3.jpg';
import ItemMenu4 from '../../../assets/images/itemMenu4.jpg';
import ItemMenu5 from '../../../assets/images/itemMenu5.jpg';
import IconSnail from '../../../assets/icons/ic-snail.svg';
import IconLeaf from '../../../assets/icons/ic-leaf2.svg';
import IconFish from '../../../assets/icons/ic-fish.svg';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import MenuItem from './MenuItem';
import { TYPE_MENU } from 'constants/common';
import ImgMenuItem1 from '../../../assets/images/menu-item/img-menu-item1.png';
import ImgMenuSo from '../../../assets/menuList/hau-so/so-nuong.jpg';
import ImgMenuHau from '../../../assets/menuList/hau-so/hau-nuong-mo-hanh.jpg';
import ImgMucChien from '../../../assets/menuList/muc/muc-chien-gion.jpg';
import ImgMucHap from '../../../assets/menuList/muc/muc-hap-hanh-gung.jpg';
import ImgMucNuong from '../../../assets/menuList/muc/muc-nuong-than-hoa.jpg';
import ImgMucXaoChua from '../../../assets/menuList/muc/muc-xao-chua-ngot.jpg';
import ImgMucXaoRau from '../../../assets/menuList/muc/muc-xao-rau.jpg';
import ImgTomSuHap from '../../../assets/menuList/tom-su/tom-su-hap.jpg';
import ImgTomSuNuong from '../../../assets/menuList/tom-su/tom-su-nuong.jpeg';
import ImgTomSuRangMe from '../../../assets/menuList/tom-su/tom-su-rang-me.jpg';
import ImgTomSashimi1 from '../../../assets/menuList/tom-su/tom-su-sashimi.1.jpg';
import ImgTomSashimi from '../../../assets/menuList/tom-su/tom-su-sashimi.jpg';
import ImgTomXaoChua from '../../../assets/menuList/tom-su/tom-su-xao-chua-ngot.jpg';
import ImgTomXaoHatDieu from '../../../assets/menuList/tom-su/tom-su-xao-hat-dieu.jpeg';
import ImgTomNhoHap from '../../../assets/menuList/tom-nho/tom-nho-hap.jpg';
import ImgTomRangMe from '../../../assets/menuList/tom-nho/tom-rang-me.jpg';
import ImgTomNhoXaoChua from '../../../assets/menuList/tom-nho/tom-xao-chua-ngot.jpg';
import ImgTomNhoChienGion from '../../../assets/menuList/tom-nho/tom-nho-chien-gion.png';
import ImgTomNhoHatDieu from '../../../assets/menuList/tom-nho/tom-xao-hat-dieu.jpg';
import ImgTomHumHap from '../../../assets/menuList/tom-hum/tom-hum-hap.jpg';
import ImgTomHumNuong from '../../../assets/menuList/tom-hum/tom-hum-nuong.jpg';
import ImgTomHumBoToi from '../../../assets/menuList/tom-hum/tom-hum-bo-toi.jpg';
import ImgCaNuong from '../../../assets/menuList/ca/ca-nuong.jpg';
import ImgCaNuong1 from '../../../assets/menuList/ca/ca-nuong-1.jpg';
import ImgCaChien from '../../../assets/menuList/ca/ca-chien-sot-ca.jpg';
import ImgCaHap from '../../../assets/menuList/ca/ca-hap.jpg';
import CuaNuong from '../../../assets/menuList/cua/cua-nuong.jpg';
import CuaHap from '../../../assets/menuList/cua/cua-hap-sa.jpg';
import CuaRangMuoi from '../../../assets/menuList/cua/cua-rang-muoi.jpg';
import CuaRangMe from '../../../assets/menuList/cua/cua-rang-me.jpg';
import Coconut from '../../../assets/menuList/drink/drink1/Whole Coconut-1.jpg';
import Pineapple from '../../../assets/menuList/drink/drink1/Pineapal.jpg';
import Passion from '../../../assets/menuList/drink/drink1/passion-fruit.jpg';
import Coconut_Shake from '../../../assets/menuList/drink/drink1/Coconut Shake.jpg';
import Orange from '../../../assets/menuList/drink/drink1/Orange.jpg';
import Mango from '../../../assets/menuList/drink/drink1/Mango.jpg';
import MixFruit from '../../../assets/menuList/drink/drink1/daiquiri-mix.jpg';
import Lemon from '../../../assets/menuList/drink/drink1/Lemon.jpg';
import Coca from '../../../assets/menuList/drink/sweet/coca.jpg';
import Pepsi from '../../../assets/menuList/drink/sweet/pepsi.jpg';
import Strong_Bow from '../../../assets/menuList/drink/sweet/strongbow.jpg';
import Heniken from '../../../assets/menuList/drink/sweet/Heniken.jpg';
import Beer333 from '../../../assets/menuList/drink/sweet/bia-333.jpg';
import BeerSpecial from '../../../assets/menuList/drink/sweet/bia-chai-saigon-special.png';
import BeerTiger from '../../../assets/menuList/drink/sweet/Bia-tiger-Crystal.png';
import MOJITO from '../../../assets/menuList/drink/drink_special/MOJITO.jpg';
import MAI_TAI from '../../../assets/menuList/drink/drink_special/mai-tai.jpg';
import COLADA from '../../../assets/menuList/drink/drink_special/Virgin Pina Colada.jpg';
import TEQUILA from '../../../assets/menuList/drink/drink_special/tequila-sunrise-1.jpg';
import CAIPIRINHA from '../../../assets/menuList/drink/drink_special/CAIPIRINHA.jpg';
import LONG_ISLAND from '../../../assets/menuList/drink/drink_special/Long-Island-Iced-Tea.jpg';
import SHIRLEY from '../../../assets/menuList/drink/drink_special/shirley-temple.jpg';
import CUBA from '../../../assets/menuList/drink/drink_special/cuba-libre-1.jpg';
import Black_Coffee from '../../../assets/menuList/drink/teavscoffee/iced-coffee-05.jpg';
import Milk_Coffee from '../../../assets/menuList/drink/teavscoffee/iced-coffee-05.jpg';
import Milkshake from '../../../assets/menuList/drink/teavscoffee/coffee-milkshake.jpg';
import Chocolate from '../../../assets/menuList/drink/teavscoffee/hot-chocolate.jpg';
import Vietnamese_Tea from '../../../assets/menuList/drink/teavscoffee/vietnamese-tea-8.jpg';
import Ginger_Tea from '../../../assets/menuList/drink/teavscoffee/Ginger-Tea-5.jpg';
import Ice_Chocolate from '../../../assets/menuList/drink/teavscoffee/iced-coffee-05.jpg';
import Vodka from '../../../assets/menuList/drink/drink_wise/VietNamese Vodka.jpg';
import Johnnie_Walker_Red from '../../../assets/menuList/drink/drink_wise/Johnnie Walker Red Label.jpg';
import Johnnie_Walker_Black from '../../../assets/menuList/drink/drink_wise/Johnnie Walker Black Label.jpg';
import Jack from '../../../assets/menuList/drink/drink_wise/Jack Daniel.jpg';
import Gordon from '../../../assets/menuList/drink/drink_wise/Gordon.jpg';
import Sminoff from '../../../assets/menuList/drink/drink_wise/Sminoff Red.jpg';
import Stolichnaya from '../../../assets/menuList/drink/drink_wise/Stolichnaya.jpg';
import Barcadi_Light from '../../../assets/menuList/drink/drink_wise/Bacardi Light.jpg';
import Barcadi_Gold from '../../../assets/menuList/drink/drink_wise/Barcadi Gold.jpg';
import Captain from '../../../assets/menuList/drink/drink_wise/Captain Morgan.jpg';
import Havana from '../../../assets/menuList/drink/drink_wise/Havana Club.jpg';
import Bailey from '../../../assets/menuList/drink/drink_wise/Bailey.jpg';
import Vietnamese_White_Wine from '../../../assets/menuList/drink/drink_wise/Vietnamese White Wine (Dalat wine)- by glass and bottle.jpg';
import Vietnamese_Red_Wine from '../../../assets/menuList/drink/drink_wise/Vietnamese White Wine (Dalat wine)- by glass and bottle.jpg';
import G7_Caberne from '../../../assets/menuList/drink/drink_wise/G7 Cabernet Sauvignon Chile G7 ( Red ).jpg';
import G7_Sauvignon from '../../../assets/menuList/drink/drink_wise/7 Sauvignon Blanc Chile G7 ( White ).jpg';
import Chardonnay from '../../../assets/menuList/drink/drink_wise/Two Ocean White Wine.jpg';
import Carbernet from '../../../assets/menuList/drink/drink_wise/Two Ocean Red Wine.jpg';
import Fresh_Fruits from '../../../assets/menuList/otherfood/Fresh Fruits Salad-1.jpg';
import Fresh_Fruits_Yoghurt from '../../../assets/menuList/otherfood/Fresh Fruits Salad with Yoghurt.jpg';
import Banana from '../../../assets/menuList/otherfood/Banana Pancake with Chocolate.jpg';
import PineappleFood from '../../../assets/menuList/otherfood/Fresh Fruits Salad-1.jpg';
import Bread_Cheese from '../../../assets/menuList/otherfood/Bread with Cheese, Tomato, onion & cucumber.jpg';
import Bread_omelette from '../../../assets/menuList/otherfood/BreadOmelette.jpg';
import Bread_chickend from '../../../assets/menuList/otherfood/BreadChicken.jpg';
import Beef_Soup from '../../../assets/menuList/otherfood/soup/sup-bo.jpg';
import Vega_Soup from '../../../assets/menuList/otherfood/soup/sup-rau.jpg';
import Other_Soup from '../../../assets/menuList/otherfood/soup/Shrimps.Clams noodle soup.jpg';
import Other_Soup1 from '../../../assets/menuList/otherfood/soup/Shrimps.Clams noodle soup1.jpg';
import Vegetables_noodle from '../../../assets/menuList/otherfood/salad/Green papaya salad with carrot,onion, mint and peanut 1.jpeg';
import Papaya_salad_shrimp from '../../../assets/menuList/otherfood/salad/Papaya salad with shrimp.jpg';
import Papaya_salad_pork from '../../../assets/menuList/otherfood/salad/Papaya salad with pork.jpg';
import Green_salad_tomato from '../../../assets/menuList/otherfood/salad/Green salad with tomato, onion and cucumber.jpg';
import Green_salad_shrimp from '../../../assets/menuList/otherfood/salad/Green salad with shrimp, tomato, onion and cucumber.jpg';
import Green_salad_squid from '../../../assets/menuList/otherfood/salad/Green salad with squid, tomato, onion and cucumber.jpg';
import Hoi_An_spring_rolls from '../../../assets/menuList/otherfood/spring-roll/cha_gio_tom.jpg';
import Imperial_spring_rolls from '../../../assets/menuList/otherfood/spring-roll/cha_gio_tuoi.jpg';
import Vegetables_spring_rolls from '../../../assets/menuList/otherfood/spring-roll/cha_gio_rau.jpg';
import Fresh_spring_rolls from '../../../assets/menuList/otherfood/spring-roll/cha_gio_tuoi.jpg';
import Fried_Cabbage_spinach from '../../../assets/menuList/otherfood/vegatable/cai_xao_toi.jpg';
import Fried_Water_spinach from '../../../assets/menuList/otherfood/vegatable/rau_muong_xao_toi.jpg';
import Fried_green_vegetables from '../../../assets/menuList/otherfood/vegatable/rau_thap_cam_xao_toi.jpg';
import Fried_Egg_plant from '../../../assets/menuList/otherfood/vegatable/ca_tim_xao.jpg';
import French_Fried from '../../../assets/menuList/otherfood/vegatable/khoa_tay_chien.jpg';
import Grilled_clams from '../../../assets/menuList/otherfood/clam/_Grilled clams with shallot.jpg';
import Steamed_clams from '../../../assets/menuList/otherfood/clam/Steamed clams with lemongrass and chilli.jpg';
import Stir_fried from '../../../assets/menuList/otherfood/clam/Stir fried clams with lemongrass and chilli.jpg';
import BananaDrink from '../../../assets/menuList/drink/drink_add/Banana.jpeg';
import Lassie from '../../../assets/menuList/drink/drink_add/Lassie.jpeg';
import Smoothies from '../../../assets/menuList/drink/drink_add/smoothie.jpeg';
import Water_Drink from '../../../assets/menuList/drink/drink_add/Big_ Small Mineral Water.jpeg';
import PINACOLADA from '../../../assets/menuList/drink/drink_add/PINACOLADA.jpeg';
import ROCKET_FUEL from '../../../assets/menuList/drink/drink_add/ROCKET FUEL.jpeg';
import Larue from '../../../assets/menuList/drink/drink_add/larue.jpeg';
import Gin_Tonic from '../../../assets/menuList/drink/drink_add/Gin Tonic.jpeg';
import Whisky_coke from '../../../assets/menuList/drink/drink_add/Whisky coke.jpeg';
import Rhum from '../../../assets/menuList/drink/drink_add/Rhum Coke.jpeg';
import Campari_Soda from '../../../assets/menuList/drink/drink_add/Campari Soda .jpeg';
import Campari from '../../../assets/menuList/drink/drink_add/Campari.jpeg';
import ga_nuong from '../../../assets/menuList/otherfood/meat/ga_nuong.jpg';
import ga_xao_xa from '../../../assets/menuList/otherfood/meat/ga_xao_xa.jpg';
import ga_xao_rau from '../../../assets/menuList/otherfood/meat/ga_xao_rau.jpg';
import ga_xao_hat from '../../../assets/menuList/otherfood/meat/ga_xao_hat.jpg';
import heo_nuong from '../../../assets/menuList/otherfood/meat/heo_nuong.jpg';
import bo_xao from '../../../assets/menuList/otherfood/meat/bo_xao.jpg';
import bo_salad from '../../../assets/menuList/otherfood/meat/salad_bo.jpg';
import mi_xao_tom from '../../../assets/menuList/otherfood/noodle/mi-xao-tom.jpg';
import mi_xao_muc from '../../../assets/menuList/otherfood/noodle/mi-xao-muc.jpeg';
import mi_xao_bo from '../../../assets/menuList/otherfood/noodle/mon-mi-xao-bo.jpg';
import mi_xao_trung from '../../../assets/menuList/otherfood/noodle/mi-xao-trung.jpeg';
import mi_xao_rau from '../../../assets/menuList/otherfood/noodle/mi-xao-rau-cu.jpg';
import { Fragment, useRef, useState } from 'react';
import { Pagination } from 'swiper';
import SwiperCore, { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';

interface IMenuItemProps {
  image: string;
  name: string;
  price: number;
  description?: string;
}

const Menu = () => {
  SwiperCore.use([Autoplay]);
  const { t } = useTranslation('header');
  const dataMenu = {
    [TYPE_MENU.MENU1]: [
      {
        image: ImgMenuSo,
        name: 'Grilled Oyster',
        price: 100000,
        description: 'Hàu nướng mỡ hành',
      },
      {
        image: ImgMenuHau,
        name: 'Grilled big seashell',
        price: 120000,
        description: 'Sò nướng',
      },
      {
        image: ImgMucChien,
        name: 'Crispy Squid ',
        price: 150000,
        description: 'Mực chiên giòn (Deep fried squid in crispy powder)',
      },
      {
        image: ImgMucNuong,
        name: 'Charcoal grilled Squid (With ginger, garlic and lemongrass)',
        price: 180000,
        description: 'Mực nướng than hoa',
      },

      {
        image: ImgMucHap,
        name: 'Steamed Squid in ginger and onion',
        price: 180000,
        description: 'Mực hấp hành gừng',
      },
      {
        image: ImgMucXaoChua,
        name: 'Sweet & sour squid (With tomato, onion & pineapple)',

        price: 150000,
        description: 'Mực xào chua ngọt',
      },
      {
        image: ImgMucXaoRau,
        name: 'Sauteed squid with vegetable',

        price: 150000,
        description: 'Mực xào rau',
      },
      {
        image: ImgTomSuHap,
        name: 'Steamed tiger prawn',
        price: 200000,
        description: 'Tôm sú hấp',
      },
      {
        image: ImgTomSuRangMe,
        name: 'Fried tiger prawn with tamarind sauce',
        price: 200000,
        description: 'Tôm sú rang me',
      },
      {
        image: ImgTomSuNuong,
        name: 'Grilled tiger prawn',
        price: 200000,
        description: 'Tôm sú nướng',
      },
      {
        image: ImgTomXaoChua,
        name: 'Stir fried tiger prawn in sweet sour sauce',
        price: 200000,
        description: 'Tôm sú xào chua ngọt',
      },
      {
        image: ImgTomXaoHatDieu,
        name: 'Stir fried tiger prawn with cashew nuts',

        price: 200000,
        description: 'Tôm sú xào hạt điều',
      },
      {
        image: ImgTomSashimi,
        name: 'Tiger prawn sashimi',

        price: 200000,
        description: 'Tôm sú sashimi',
      },
      {
        image: ImgTomNhoHap,
        name: 'Steamed tiger prawn',
        price: 150000,
        description: 'Tôm nhỏ hấp',
      },
      {
        image: ImgTomRangMe,
        name: 'Fried tiger prawn with tamarind sauce',
        price: 150000,
        description: 'Tôm nhỏ rang me',
      },
      {
        image: ImgTomNhoXaoChua,
        name: 'Stir fried tiger prawn in sweet sour sauce',
        price: 150000,
        description: 'Tôm nhỏ xào chua ngọt',
      },
      {
        image: ImgTomNhoHatDieu,
        name: 'Stir fried tiger prawn with cashew nuts',
        price: 150000,
        description: 'Tôm nhỏ xào hạt điều',
      },
      {
        image: ImgTomNhoChienGion,
        name: 'Crispy prawn',

        price: 150000,
        description: 'Tôm nhỏ chiên giòn',
      },
      {
        image: ImgTomSuNuong,
        name: 'Grilled prawn',

        price: 150000,
        description: 'Tôm nhỏ nướng',
      },
      {
        image: ImgTomHumNuong,
        name: 'Grilled lobster',
        price: 900000,
        description: 'Tôm hùm nướng',
      },
      {
        image: ImgTomHumHap,
        name: 'Steamed lobster',
        price: 900000,
        description: 'Tôm hùm hấp',
      },
      {
        image: ImgTomHumBoToi,
        name: 'Fried lobster with butter garlic',
        price: 900000,
        description: 'Tôm hùm chiên bơ tỏi',
      },
      {
        image: ImgCaNuong,
        name: 'Grilled Whole Fish (Fish mix with ginger, garlic, lemon grass)',

        price: 160000,
        description: 'Cá nướng',
      },
      {
        image: ImgCaHap,
        name: 'Steamed Whole Fish (Red Snapper (Fish mix with mushroom, onion, glass noodle)',

        price: 160000,
        description: 'Cá hấp',
      },
      {
        image: ImgCaChien,
        name: 'Deep fried Fish with tomato sauce',
        price: 160000,
        description: 'Cá chiên sốt cà chua',
      },
      {
        image: CuaNuong,
        name: 'Grilled crab with lime, salt & pepper',

        price: 200000,
        description: 'Cua nướng',
      },
      {
        image: CuaHap,
        name: 'Steamed Crab with Lemonglass',

        price: 200000,
        description: 'Cua hấp sả',
      },
      {
        image: CuaRangMe,
        name: 'Fried crab with tamarind sauce',
        price: 200000,
        description: 'Cua rang me',
      },
      {
        image: CuaRangMuoi,
        name: 'Fried Crab with local spices',
        price: 200000,
        description: 'Cua rang muối',
      },
    ],
    [TYPE_MENU.MENU2]: [
      {
        image: Coconut,
        name: 'Whole Coconut',
        price: 40000,
      },
      {
        image: Pineapple,
        name: 'Pineapple',
        price: 40000,
      },

      {
        image: Passion,
        name: 'Passion Fruit',
        price: 40000,
      },
      {
        image: BananaDrink,
        name: 'Banana',

        price: 40000,
      },
      {
        image: Coconut_Shake,
        name: 'Coconut Shake',

        price: 40000,
      },
      {
        image: Orange,
        name: 'Orange',
        price: 40000,
      },
      {
        image: Mango,
        name: 'Mango',
        price: 40000,
      },

      {
        image: Lemon,
        name: 'Lemon Juice',
        price: 40000,
      },
      {
        image: Lassie,
        name: 'Lassie',

        price: 60000,
      },
      {
        image: Smoothies,
        name: 'Smoothies',

        price: 60000,
      },
      {
        image: MixFruit,
        name: 'Mixed fruit',

        price: 60000,
      },
      {
        image: Coca,
        name: 'Coca- Mirinda- 7up- Lipton Icetea- Soda Water',
        price: 20000,
      },
      {
        image: Pepsi,
        name: 'Pepsi- Fanta- Sprite- Tonic Water- Diet Coke- Redbull',
        price: 20000,
      },

      {
        image: Water_Drink,
        name: 'Big/ Small Mineral Water',
        price: 20000,
      },
      {
        image: BeerTiger,
        name: 'Tiger',

        price: 25000,
      },
      {
        image: BeerSpecial,
        name: 'Sai Gon',

        price: 20000,
      },
      {
        image: Heniken,
        name: 'Heineken',
        price: 25000,
      },
      {
        image: Larue,
        name: 'Larue',
        price: 20000,
      },
      {
        image: Beer333,
        name: '333',
        price: 25000,
      },
      {
        image: Strong_Bow,
        name: 'Strong Bow ',
        price: 40000,
      },

      {
        image: PINACOLADA,
        name: 'PINACOLADA',
        price: 70000,
        description: '(Barcadi,Coconut cream and Pineapple juice)',
      },
      {
        image: MOJITO,
        name: 'MOJITO',
        price: 70000,
        description: '(Barcadi, Fresh Lime, Fresh mint, Grenadine & Soda)',
      },
      {
        image: MAI_TAI,
        name: 'MAI TAI',
        price: 80000,
        description: '(Light Rhum,Dark Rhum,Pineapple Juice, Lime Juice and Grenadine)',
      },
      {
        image: COLADA,
        name: 'VIRGIN COLADA',
        price: 60000,
        description: '(Coconut cream and Pineapple Juice)',
      },
      {
        image: TEQUILA,
        name: 'TEQUILA SUNRISE',
        price: 80000,
        description: '(Tequila, Orange juice and Grenadine)',
      },
      {
        image: CAIPIRINHA,
        name: 'CAIPIRINHA',
        price: 80000,
        description: '(Barcadi, Fresh Lime and Sugar)',
      },
      {
        image: LONG_ISLAND,
        name: 'LONG ISLAND ICE TEA',
        price: 90000,
        description: '(Vodka, Gin, Tequila, Rhum, Cointreau, Coke and Lime Juice)',
      },
      {
        image: ROCKET_FUEL,
        name: 'ROCKET FUEL',
        price: 90000,
        description: '(Gin, Vodka, Rhum, Tequila and 7up)',
      },
      {
        image: SHIRLEY,
        name: 'SHIRLEY TEMPLE',
        price: 50000,
        description: '(Grenadine and 7 up)',
      },
      {
        image: CUBA,
        name: 'CUBA LIBRE',
        price: 70000,
        description: '(Barcadi,Lime juice and coke)',
      },
      {
        image: Black_Coffee,
        name: 'Hot/Ice Black Coffee',
        price: 30000,
      },
      {
        image: Milk_Coffee,
        name: 'Hot/Ice Milk Coffee',

        price: 30000,
      },
      {
        image: Milkshake,
        name: 'Coffee milkshake',

        price: 30000,
      },
      {
        image: Ice_Chocolate,
        name: 'Hot/Ice Chocolate',
        price: 30000,
      },
      {
        image: Vietnamese_Tea,
        name: 'Lipton Tea ',
        price: 30000,
      },
      {
        image: Vietnamese_Tea,
        name: 'Vietnamese green tea',
        price: 30000,
      },
      {
        image: Ginger_Tea,
        name: 'Ginger tea',
        price: 30000,
      },

      {
        image: Gin_Tonic,
        name: 'Gin Tonic',
        price: 50000,
      },
      {
        image: Whisky_coke,
        name: 'Whisky coke',
        price: 50000,
      },
      {
        image: Rhum,
        name: 'Rhum Coke',
        price: 50000,
      },
      {
        image: Vodka,
        name: 'Vodka 7 up',
        price: 50000,
      },
      {
        image: Campari_Soda,
        name: 'Campari Soda',
        price: 50000,
      },
      {
        image: Campari,
        name: 'Campari',
        price: 45000,
      },
      {
        image: Johnnie_Walker_Red,
        name: 'Johnnie Walker Red Label',
        price: 50000,
      },
      {
        image: Johnnie_Walker_Black,
        name: 'Johnnie Walker Black Label',
        price: 60000,
      },
      {
        image: Jack,
        name: 'Jack Daniel’s',
        price: 50000,
      },
      {
        image: Gordon,
        name: 'Gordon’s',
        price: 40000,
      },
      {
        image: Sminoff,
        name: 'Sminoff Red',
        price: 40000,
      },
      {
        image: Stolichnaya,
        name: 'Stolichnaya',
        price: 40000,
      },
      {
        image: Vodka,
        name: 'VietNamese Vodka',
        price: 25000,
      },
      {
        image: Barcadi_Light,
        name: 'Barcadi Light',
        price: 40000,
      },
      {
        image: Barcadi_Gold,
        name: 'Barcadi Gold',
        price: 40000,
      },
      {
        image: Captain,
        name: 'Captain Morgan',
        price: 45000,
      },
      {
        image: Havana,
        name: 'Havana Club',
        price: 40000,
      },
      {
        image: Bailey,
        name: 'Bailey’s',
        price: 55000,
      },
      {
        image: Vietnamese_White_Wine,
        name: 'Vietnamese White Wine (Dalat wine)- by glass and bottlea',
        price: 55000,
      },
      {
        image: Vietnamese_Red_Wine,
        name: 'Vietnamese Red Wine (Dalat wine)- by glass and bottle',
        price: 55000,
      },
      {
        image: G7_Caberne,
        name: 'G7 Cabernet Sauvignon Chile G7 ( Red )',
        price: 55000,
      },
      {
        image: G7_Sauvignon,
        name: 'G7 Sauvignon Blanc Chile G7 ( White )',
        price: 55000,
      },
      {
        image: Chardonnay,
        name: 'Two Ocean White Wine Chardonnay, Sauvignon Blanc - by bottle only',
        price: 55000,
      },
      {
        image: Carbernet,
        name: 'Two Ocean White Wine Carbernet Merlot - by bottle only',
        price: 55000,
      },
    ],
    [TYPE_MENU.MENU3]: [
      {
        image: Fresh_Fruits,
        name: 'Fresh Fruits Salad ',
        price: 60000,
        description: 'Trái cây thập cẩm',
      },
      {
        image: Fresh_Fruits_Yoghurt,
        name: 'Fresh Fruits Salad with Yoghurt',
        price: 70000,
        description: 'Salad trái cây tươi với sữa chua',
      },
      {
        image: Banana,
        name: 'Banana Pancake with Chocolate',
        price: 50000,
        description: 'Bánh sôcôla chuối',
      },
      {
        image: PineappleFood,
        name: 'Pineapple Pancake with Chocolate',
        price: 50000,
        description: 'Bánh sôcôla thơm',
      },
      {
        image: Bread_Cheese,
        name: 'Bread w/ Cheese, Tomato, onion & cucumber',

        price: 40000,
        description: 'Bánh mì bơ hành cà',
      },
      {
        image: Bread_omelette,
        name: 'Bread omelette',

        price: 40000,
        description: 'Bánh mì trứng (Egg with tomato, onion & cucumber)',
      },
      {
        image: Bread_chickend,
        name: 'Bread with chicken/pork/tuna fish, tomato, onion & cucumber',

        price: 50000,
        description: 'Bánh mì gà / Heo/ Cá ngừ ',
      },
      {
        image: Other_Soup1,
        name: 'Shrimps/Clams noodle soup',
        price: 80000,
        description: 'Súp Tôm/Nghêu (Shrimp with noodle, tomato, onion)',
      },
      {
        image: Other_Soup,
        name: 'Crab noodle soup',
        price: 100000,
        description: 'Súp Cua (Crab with noodle, tomato, onion)',
      },
      {
        image: Beef_Soup,
        name: 'Beef/ Chicken/ Pork noodle soup',
        price: 80000,
        description: 'Súp Bò/ Gà/ Heo- (Beef / Chicken/ Pork with noodle, green vegetables)',
      },
      {
        image: Vega_Soup,
        name: 'Vegetables noodle soup',
        price: 60000,
        description: 'Súp Rau- (Noodle w/ green vegetables)',
      },
      {
        image: Grilled_clams,
        name: 'Grilled clams with shallot',

        price: 100000,
        description: 'Nghêu nướng sa tế',
      },
      {
        image: Steamed_clams,
        name: 'Steamed clams with lemongrass and chilli',

        price: 100000,
        description: 'Nghêu hấp với lá chanh và ớt',
      },
      {
        image: Stir_fried,
        name: 'Stir fried clams with lemongrass and chilli ',

        price: 80000,
        description: 'Nghêu xào cay',
      },
      {
        image: Vegetables_noodle,
        name: 'Vegetables noodle Green papaya salad with carrot,onion, mint and peanut',
        price: 70000,
        description: 'Gỏi đu đủ',
      },
      {
        image: Papaya_salad_shrimp,
        name: 'Papaya salad with shrimp',

        price: 100000,
        description: 'Gỏi tôm đu đủ',
      },
      {
        image: Papaya_salad_pork,
        name: 'Papaya salad with pork',

        price: 90000,
        description: 'Gỏi thịt đu đủ',
      },
      {
        image: Green_salad_tomato,
        name: 'Green salad with tomato, onion and cucumber',

        price: 70000,
        description: 'Salad chay',
      },
      {
        image: Green_salad_shrimp,
        name: 'Green salad with shrimp, tomato, onion and cucumber',

        price: 100000,
        description: 'Salad tôm',
      },
      {
        image: Green_salad_squid,
        name: 'Green salad with squid, tomato, onion and cucumber',

        price: 100000,
        description: 'Salad mực',
      },
      {
        image: Hoi_An_spring_rolls,
        name: 'Hoi An spring rolls ',

        price: 80000,
        description: 'Chả giò tôm (Shrimp with vegetables)',
      },
      {
        image: Imperial_spring_rolls,
        name: 'Imperial spring rolls',

        price: 80000,
        description: 'Chả giò thịt (Meat with vegetables)',
      },
      {
        image: Vegetables_spring_rolls,
        name: 'Vegetables spring rolls',

        price: 60000,
        description: 'Chả giò rau',
      },
      {
        image: Fresh_spring_rolls,
        name: 'Fresh spring rolls',

        price: 80000,
        description: 'Chả giò tươi (Shrimp w/ green salad)',
      },
      {
        image: Fried_Water_spinach,
        name: 'Fried Water spinach (morning glory) with garlic',

        price: 50000,
        description: 'Rau muống xào tỏi',
      },
      {
        image: Fried_Cabbage_spinach,
        name: 'Fried Cabbage with garlic ',

        price: 50000,
        description: 'Cải xào tỏi',
      },
      {
        image: Fried_green_vegetables,
        name: 'Fried green vegetables',

        price: 60000,
        description: 'Rau thập cẩm xào tỏi',
      },
      {
        image: Fried_Egg_plant,
        name: 'Fried Egg plant with tomato sauce',

        price: 50000,
        description: 'Cà tím xào chua ngọt',
      },
      {
        image: French_Fried,
        name: 'French Fried (Potatoes-Chips)',

        price: 70000,
        description: 'Khoai Tây Chiên',
      },
      {
        image: ga_nuong,
        name: 'Charcoal grilled Chicken in spicy sauce',

        price: 100000,
        description: 'Gà nướng ngũ vị',
      },
      {
        image: ga_xao_xa,
        name: 'Stir fried chicken with lemon grass and chilly',

        price: 100000,
        description: 'Gà xào sả ớt',
      },
      {
        image: ga_xao_rau,
        name: 'Stir fried chicken with vegetables',

        price: 100000,
        description: 'Gà xào rau thập cẩm',
      },
      {
        image: ga_xao_hat,
        name: 'Stir fried chicken with cashew nuts',

        price: 100000,
        description: 'Gà xào hạt diều',
      },
      {
        image: ga_nuong,
        name: 'Charcoal grilled Chicken in spicy sauce',

        price: 100000,
        description: 'Gà nướng ngũ vị',
      },
      {
        image: heo_nuong,
        name: 'Charcoal grilled Beef / Pork in spicy sauce',

        price: 100000,
        description: 'Bò/ Heo nướng ngũ vị',
      },
      {
        image: bo_xao,
        name: 'Stir fried beef/ Pork with vegetables',

        price: 100000,
        description: 'Bò/ Heo xào rau',
      },
      {
        image: bo_salad,
        name: 'Sauteed slice Beef tederloin',

        price: 100000,
        description: 'Bò salad',
      },
      {
        image: mi_xao_tom,
        name: 'Stir fried noodle with shrimps and green vegetable',

        price: 100000,
        description: 'Mì xào tôm',
      },
      {
        image: mi_xao_muc,
        name: 'Stir fried noodle with squids and green vegetable',

        price: 100000,
        description: 'Mì xào Mực',
      },
      {
        image: mi_xao_bo,
        name: 'Stir fried noodle with meat, vegetables',

        price: 100000,
        description: 'Mì xào Gà/Heo/Bò và rau',
      },
      {
        image: mi_xao_trung,
        name: 'Stir fried noodle with eggs and vegetables',

        price: 100000,
        description: 'Mì xào trứng',
      },
      {
        image: mi_xao_rau,
        name: 'Stir fried noodle with green vegetables',

        price: 100000,
        description: 'Mì xào rau thập cẩm',
      },
    ],
  };
  const menuRef: any = useRef();
  const [visibleItems, setVisibleItems] = useState(14);
  const getFoodMenu = (type: string) => {
    const listMenu = dataMenu[type];
    return listMenu;
  };
  const handleShowMore = (type: string) => {
    setVisibleItems((prevCount: number) => {
      const newCount = prevCount + 14;
      return newCount > getFoodMenu(type).length ? getFoodMenu(type).length : newCount;
    });
  };
  const handleBack = (type: string) => {
    setVisibleItems(14);
    menuRef.current.scrollIntoView({ behavior: 'smooth' });
  };
  const renderMenuItem = (type: string) => {
    const listMenu = dataMenu[type];

    return (
      listMenu?.length > 0 &&
      listMenu.slice(0, visibleItems).map((menuItem: IMenuItemProps, menuIndex: number) => (
        <Fragment key={menuIndex}>
          <MenuItem
            image={menuItem.image}
            name={menuItem.name}
            price={menuItem.price}
            description={menuItem.description}
          />
        </Fragment>
      ))
    );
  };

  return (
    <div id="menu" className="relative px-4 xl:px-[100px] mt-9 xl:mt-[100px]" ref={menuRef}>
      <h4 className="text-orange-300 font-dancing-script text-[16px] xl:text-[24px] font-semibold xl:font-bold text-center">
        Menu
      </h4>
      <h2 className="text-primary text-[24px] xl:text-[32px] font-extrabold text-center">
        {t('menu.titleMain')}
      </h2>

      <div className="menu-tabs mt-6">
        <Tabs>
          <TabList>
            <Tab
              style={{
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              {t('menu.inforMenu.menu1')}
            </Tab>
            <Tab
              style={{
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              {t('menu.inforMenu.menu2')}
            </Tab>
            <Tab
              style={{
                textTransform: 'uppercase',
                cursor: 'pointer',
              }}
            >
              {t('menu.inforMenu.menu3')}
            </Tab>
          </TabList>

          <TabPanel>
            <div className="relative z-[1]">
              <div className="grid xl:grid-cols-2 grid-cols-1 gap-8">
                {renderMenuItem(TYPE_MENU.MENU1)}
              </div>
              {getFoodMenu(TYPE_MENU.MENU1).length === visibleItems ? (
                <div className="text-center">
                  <button
                    className="mt-8 bg-orange-300 rounded-[5px] px-4 py-2 text-[14px] font-semibold text-white"
                    onClick={() => handleBack(TYPE_MENU.MENU1)}
                  >
                    {t('button.backMenu')}
                  </button>
                </div>
              ) : (
                <div className="text-center">
                  <button
                    className="mt-8 bg-orange-300 rounded-[5px] px-4 py-2 text-[14px] font-semibold text-white"
                    onClick={() => handleShowMore(TYPE_MENU.MENU1)}
                  >
                    {t('button.seeMore')}
                  </button>
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="relative z-[1]">
              <div className="grid xl:grid-cols-2 grid-cols-1 gap-8">
                {renderMenuItem(TYPE_MENU.MENU2)}
              </div>

              {getFoodMenu(TYPE_MENU.MENU2).length === visibleItems ? (
                <div className="text-center">
                  <button
                    className="mt-8 bg-orange-300 rounded-[5px] px-4 py-2 text-[14px] font-semibold text-white"
                    onClick={() => handleBack(TYPE_MENU.MENU2)}
                  >
                    {t('button.backMenu')}
                  </button>
                </div>
              ) : (
                <div className="text-center">
                  <button
                    className="mt-8 bg-orange-300 rounded-[5px] px-4 py-2 text-[14px] font-semibold text-white"
                    onClick={() => handleShowMore(TYPE_MENU.MENU2)}
                  >
                    {t('button.seeMore')}
                  </button>
                </div>
              )}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="relative z-[1]">
              <div className="grid xl:grid-cols-2 grid-cols-1  gap-8">
                {renderMenuItem(TYPE_MENU.MENU3)}
              </div>

              {getFoodMenu(TYPE_MENU.MENU3).length === visibleItems ? (
                <div className="text-center">
                  <button
                    className="mt-8 bg-orange-300 rounded-[5px] px-4 py-2 text-[14px] font-semibold text-white"
                    onClick={() => handleBack(TYPE_MENU.MENU3)}
                  >
                    {t('button.backMenu')}
                  </button>
                </div>
              ) : (
                <div className="text-center">
                  <button
                    className="mt-8 bg-orange-300 rounded-[5px] px-4 py-2 text-[14px] font-semibold text-white"
                    onClick={() => handleShowMore(TYPE_MENU.MENU3)}
                  >
                    {t('button.seeMore')}
                  </button>
                </div>
              )}
            </div>
          </TabPanel>
        </Tabs>
      </div>

      <div className="absolute top-[30%] left-[-20px]">
        <img src={IconSnail} alt="snail" className="w-[70px] h-auto xl:w-auto" />
      </div>

      <div className="absolute top-[50%] right-[-70px] xl:right-[-170px]">
        <img src={IconLeaf} alt="leaf" className="w-[130px] h-auto xl:w-auto" />
      </div>

      <div className="absolute top-[80%] xl:top-[70%] left-[-200px] xl:left-[-300px]">
        <img src={IconFish} alt="fish" className="w-[330px] h-auto xl:w-auto" />
      </div>

      <div className="relative mt-9 xl:mt-[100px]">
        <div className="relative z-0">
          <Swiper slidesPerView={1} pagination={true} modules={[Pagination]} loop={true} autoplay>
            <SwiperSlide>
              <div>
                <img
                  src={ItemMenu1}
                  alt="ItemMenu1"
                  className="xl:object-cover w-full xl:w-[70%] !xl:h-[600px] !min-h-[350px] !max-h-[400px]"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img
                  src={ItemMenu2}
                  alt="ItemMenu1"
                  className="xl:object-cover w-full xl:w-[70%] xl:h-[600px] !min-h-[350px] !max-h-[400px]"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img
                  src={ItemMenu3}
                  alt="ItemMenu1"
                  className="xl:object-cover w-full xl:w-[70%] xl:h-[600px] !min-h-[350px] !max-h-[400px]"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img
                  src={ItemMenu4}
                  alt="ItemMenu1"
                  className="xl:object-cover w-full xl:w-[70%] !xl:h-[600px] !min-h-[350px] !max-h-[400px]"
                />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <img
                  src={ItemMenu5}
                  alt="ItemMenu1"
                  className="xl:object-cover w-full xl:w-[70%] xl:h-[600px] !min-h-[350px] !max-h-[400px]"
                />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="mt-4 xl:mt-0 xl:absolute xl:right-0 xl:top-[100px] bg-blue-50 xl:border-[24px] xl:border-white xl:w-[50%] p-4 xl:p-6">
          <h4 className="text-orange-300 font-dancing-script text-[16px] xl:text-[24px] font-bold">
            {t('menu.titleRes')}
          </h4>
          <h2 className="xl:mt-2 text-primary text-[24px] xl:text-[32px] font-bold xl:font-extrabold">
            {t('menu.title')}
          </h2>
          <p className="mt-4 text-grey-100 text-[14px] xl:text-[16px] leading-[20px] xl:leading-[22px]">
            {t('menu.introduce')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Menu;
